var map = {
	"./404.svg": 943,
	"./Categories.png": 944,
	"./Edit-menu.svg": 945,
	"./Egg.svg": 946,
	"./Emaier-Header.png": 947,
	"./Qr-4.png": 948,
	"./_duplicate.svg": 949,
	"./_overview.svg": 950,
	"./add-white.svg": 951,
	"./alert.svg": 952,
	"./all_category.svg": 953,
	"./archive.svg": 954,
	"./armchair.svg": 955,
	"./arrow-circle-right.svg": 956,
	"./arrow-left-circle.svg": 957,
	"./arrow-right-circle.svg": 958,
	"./arrow-right.svg": 959,
	"./asc-up-white.svg": 960,
	"./asc.png": 961,
	"./asc.svg": 962,
	"./back-arrow.svg": 963,
	"./barcode-icon.svg": 964,
	"./beverages.svg": 965,
	"./blue-edit-pen.svg": 966,
	"./blue-eye.svg": 967,
	"./box-office.svg": 968,
	"./broken-seat.jpg": 969,
	"./calendar_list.svg": 970,
	"./calender.svg": 353,
	"./chevron-down.svg": 971,
	"./chevron-left.svg": 972,
	"./cinema-mamagement-sidebar.svg": 973,
	"./claendar.svg": 303,
	"./clock-1.svg": 974,
	"./clock.svg": 975,
	"./close-button.svg": 703,
	"./close-white.svg": 706,
	"./close-x.svg": 297,
	"./collapse-up.svg": 976,
	"./collapse.svg": 977,
	"./connection-lost.svg": 351,
	"./consumable-raw-material.svg": 978,
	"./copy.svg": 979,
	"./copy_image_icon.png": 980,
	"./delete-red-light.svg": 981,
	"./delete-red.svg": 712,
	"./delete.svg": 686,
	"./deliver-icon.svg": 982,
	"./desc-down-white.svg": 983,
	"./desc.svg": 984,
	"./distributors-sidebar.svg": 985,
	"./download.svg": 986,
	"./dragndrop.svg": 987,
	"./dragndrop2.svg": 988,
	"./duplicate.svg": 989,
	"./duplicateScreen.svg": 990,
	"./e-wallet-icon-black.svg": 991,
	"./edit-pen-blue.svg": 992,
	"./edit-pen-white.svg": 993,
	"./edit-pen.svg": 994,
	"./edit.svg": 995,
	"./email.png": 996,
	"./empty-image.svg": 997,
	"./excel.svg": 998,
	"./external-link.svg": 999,
	"./eye.svg": 1000,
	"./filter-icon.svg": 1001,
	"./flag.svg": 1002,
	"./fnb-app-order.svg": 1003,
	"./fnb-beverages.svg": 1004,
	"./fnb-brownie.svg": 1005,
	"./fnb-combo.svg": 1006,
	"./fnb-desert.svg": 1007,
	"./fnb-eatables.svg": 1008,
	"./fnb-make-your-combo.svg": 1009,
	"./fnb-popcorn.svg": 1010,
	"./fnbtransactionIcon.svg": 1011,
	"./fullscreen-icon.svg": 713,
	"./funnel.svg": 1012,
	"./globe.svg": 1013,
	"./green-tick.svg": 1014,
	"./grid-view.svg": 1015,
	"./hide-password.svg": 354,
	"./home-icon.svg": 1016,
	"./home.svg": 1017,
	"./icon-black-play.svg": 1018,
	"./icon-dot.svg": 1019,
	"./icon-fnb.svg": 1020,
	"./icon-marketing.svg": 1021,
	"./icon-no-seat.png": 1022,
	"./icon-no-seat.svg": 1023,
	"./icon-option.svg": 1024,
	"./icon-poin-of-sale.svg": 1025,
	"./icon-recliner.svg": 1026,
	"./icon-report.svg": 1027,
	"./icon-sofa-dark-1.svg": 1028,
	"./icon-sofa-dark.png": 1029,
	"./icon-sofa-dark.svg": 1030,
	"./icon-sofa.svg": 1031,
	"./importfile.svg": 1032,
	"./info.svg": 707,
	"./info2.svg": 1033,
	"./keyboard-icon.svg": 1034,
	"./kitchen_display.svg": 1035,
	"./language-icon.svg": 298,
	"./left-caret.svg": 1036,
	"./link.svg": 1037,
	"./list-view.svg": 1038,
	"./loading.svg": 355,
	"./lock.svg": 1039,
	"./login-password.png": 356,
	"./login-user.png": 357,
	"./logout.svg": 708,
	"./masters-sidebar.svg": 1040,
	"./merchandise.svg": 1041,
	"./minus.svg": 1042,
	"./movie-pass-svg.svg": 696,
	"./movie-rolling.svg": 1043,
	"./mulitSchedule.svg": 1044,
	"./multicurrency.svg": 1045,
	"./multifnb.svg": 1046,
	"./nav-plus.svg": 1047,
	"./new_filter_icon.svg": 1048,
	"./no-image.svg": 1049,
	"./no-schedule.svg": 134,
	"./non-veg-mark.png": 1050,
	"./non-veg-mark.svg": 1051,
	"./notification.svg": 1052,
	"./open-link-blue.svg": 1053,
	"./openPlanned.svg": 1054,
	"./overview.svg": 1055,
	"./overview2.svg": 1056,
	"./pdf-icon.svg": 1057,
	"./pdf.svg": 1058,
	"./pickup-ticket-icon.svg": 1059,
	"./pickupfnb.svg": 1060,
	"./play.svg": 1061,
	"./plus.svg": 1062,
	"./pointofsale-1.svg": 1063,
	"./pointofsale-2.svg": 1064,
	"./pointofsale.png": 1065,
	"./portfolio.svg": 1066,
	"./pos-fnb-no-itmes.svg": 699,
	"./pos-refresh.svg": 1067,
	"./primary/chevron-down.svg": 1068,
	"./primary/download.svg": 1069,
	"./primary/edit.svg": 1070,
	"./primary/filter.svg": 1071,
	"./primary/printer.svg": 1072,
	"./print-icon.svg": 1073,
	"./print.svg": 1074,
	"./question.svg": 1075,
	"./question1.svg": 1076,
	"./question2.svg": 714,
	"./question3.svg": 1077,
	"./recliner-1.svg": 1078,
	"./recliner.png": 1079,
	"./refund-icon.svg": 1080,
	"./reload-icon-pos.svg": 1081,
	"./reload-icon.svg": 1082,
	"./restore.svg": 1083,
	"./right-caret.svg": 1084,
	"./role-management-sidebar.svg": 1085,
	"./save.svg": 1086,
	"./schedule-icon.svg": 1087,
	"./school-calendar.svg": 1088,
	"./search-global-white.svg": 1089,
	"./search-global.svg": 1090,
	"./search.svg": 715,
	"./searchIcon.svg": 1091,
	"./seat-icon-2.svg": 1092,
	"./seat-icon.svg": 1093,
	"./seat-icons/3-wheelChair.png": 1094,
	"./seat-icons/block_seat_new.png": 1095,
	"./seat-icons/broken-seat-1.svg": 1096,
	"./seat-icons/broken-seat-2.svg": 1097,
	"./select-food.png": 716,
	"./settings.svg": 1098,
	"./show-password.svg": 358,
	"./slider-triangle.svg": 1099,
	"./snack.svg": 709,
	"./sort.svg": 1100,
	"./star-empty.svg": 1101,
	"./star-fill.svg": 1102,
	"./success-tick.svg": 1103,
	"./suitcase.svg": 1104,
	"./swap.svg": 1105,
	"./tick-green-item.svg": 717,
	"./tick-green.svg": 1106,
	"./ticket-icon.svg": 1107,
	"./trash.svg": 1108,
	"./unpaid-reservation.svg": 690,
	"./updown-white.svg": 1109,
	"./updown.svg": 1110,
	"./user-attribute.svg": 1111,
	"./user-attributes.svg": 1112,
	"./user-female.svg": 1113,
	"./user-male-white.svg": 1114,
	"./user-male.svg": 1115,
	"./user-profile.svg": 1116,
	"./userProfile.png": 1117,
	"./veg-food-mark-white.png": 1118,
	"./veg-foog-mark-trans.png": 1119,
	"./view.png": 1120,
	"./view.svg": 1121
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 942;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 942
// module chunks = 37